import { FirmInfoType } from '@/components/settings-page/platformSettings/firmInfo';
import { Text, View } from '@react-pdf/renderer';
import { DefaultTheme } from 'styled-components/dist/types';
import { formatFirmAddress, formatFirmContactInfo } from '../../utils';
import { templateStyles } from '../style';

interface PDFTemplateFooterProps {
  firmInfoData: FirmInfoType;
  theme: DefaultTheme;
}

export const PDFTemplateFooter = ({ firmInfoData, theme }: PDFTemplateFooterProps) => {
  return (
    <View style={templateStyles.footerWrap} fixed>
      <View style={{ ...templateStyles.footer, color: theme.font.weak }}>
        <View style={templateStyles.footerSectionWrap}>
          <Text style={{ ...templateStyles.firmName, color: theme.font.base }}>{firmInfoData?.firmName ?? ''}</Text>
        </View>
        <View style={templateStyles.footerSectionWrap}>
          <Text style={templateStyles.firmAddress}>{formatFirmAddress(firmInfoData)}</Text>
        </View>
        <View style={templateStyles.footerSectionWrap}>
          <Text>{formatFirmContactInfo(firmInfoData)}</Text>
        </View>
      </View>
    </View>
  );
};
